import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Platform } from "types/platform";

export interface PlatformGroup {
  label: string | null;
  id: string;
  name: string;
  platforms: Platform[];
}

export const usePlatformGroups = () => {
  const [platformGroups, setPlatformGroups] = React.useState<PlatformGroup[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const [creating, setCreating] = React.useState(false);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => await getPlatformGroups())();
  }, []);

  const getPlatformGroups = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.PlatformGroups}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      
      
      setPlatformGroups(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  const createPlatformGroup = async (name: string, ids: string[]) => {
    try {
      setCreating(true);
      await axios.post(
        `${API_BASE_URL}${API_URLS.PlatformGroups}`,
        { name, platform_ids: ids },
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      await getPlatformGroups();
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  };

  const upDatePlatformGroup = async (id: string, name: string, ids: number[]) => {
    try {
      
      setCreating(true);
        const url = `${API_BASE_URL}${API_URLS.PlatformGroupsUpdate.replace('{platformGroup}', id)}`;
  
      await axios.put(
        url,
        {
          ...(name ? { name } : {}),
          platform_ids: ids,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      await getPlatformGroups();
    } catch (e) {
      console.error("Update error:", e);
    } finally {
      setCreating(false);
    }
  };
  

  const removePlatformGroup = async (id: string) => {
    try {
      
      setCreating(true);
      await axios.delete(
        `${API_BASE_URL}${API_URLS.PlatformGroups}/${id}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      await getPlatformGroups();
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  };

  return {
    platformGroups,
    createPlatformGroup,
    removePlatformGroup,
    upDatePlatformGroup,
    refresh: getPlatformGroups,
    fetching,
    creating
  };
};
